import { render, staticRenderFns } from "./modal-change-assignee.vue?vue&type=template&id=3ca11e37&scoped=true"
import script from "./modal-change-assignee.vue?vue&type=script&lang=js"
export * from "./modal-change-assignee.vue?vue&type=script&lang=js"
import style0 from "./modal-change-assignee.vue?vue&type=style&index=0&id=3ca11e37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca11e37",
  null
  
)

export default component.exports